// One search action works on the People tab the admin is actually viewing.
// Browsing a person's profile searches the corresponding list, not the
// default departmental landing page. This never queries cross-tenant data.
export function buildPortalPeopleSearchUrl(pathname, search, defaultHref, rawQuery) {
  const query = String(rawQuery || '').trim();
  if (!query) return null;
  const path = String(pathname || '');
  const destination = path.startsWith('/portal/recruitment')
    ? '/portal/recruitment'
    : path.startsWith('/portal/employees')
      ? '/portal/employees'
      : (defaultHref || '/portal/employees');
  const params = destination === '/portal/employees' && path.startsWith('/portal/employees')
    ? new URLSearchParams(search || '') : new URLSearchParams();
  params.set('q', query);
  return `${destination}?${params.toString()}`;
}
